import React from 'react';
import {Outlet, useLocation} from "react-router-dom";
import Menu from "../components/Menu";
import styled from "styled-components";
import NotificationModal from "../components/NotificationModal";
import {useAppSelector} from "../hooks/hooks";

const RootWrapper: React.FC = () => {
    const {pathname} = useLocation();
    const data = useAppSelector((state) => state.user.data);

    if(!data.jwt_token) {
        window.location.replace('/');
    }

    return (
        <Container pathname={pathname}>
            <NotificationModal/>
            <Outlet />
            <Menu/>
        </Container>
    );
};

export default RootWrapper;

// Changing styles depending on pathname (/codes) for Codes page, to remove Menu lifting with Virtual Keyboard on Android devices
const Container = styled.div<{pathname:string}>`
    height: 100%;
    position: relative;
    display: ${({pathname}) => (pathname === "/codes" || pathname === "/tutorial/codes") ? "flex" : "block"};
    ${({pathname}) => (pathname === "/codes" || pathname === "/tutorial/codes") && "flex-direction: column"};
    ${({pathname}) => (pathname === "/codes" || pathname === "/tutorial/codes") && "justify-content: space-between"};
`;
